import {
  ResponseMappingError,
  reqArray,
  reqRecord,
} from '@shared/value-objects/parse-helpers';
import type { Lawyer } from './model';
import { parseLawyer } from './parseLawyer';

/// メール専用 API (`/api/lawyers/{id}/emails`) のレスポンス門番 (CU-86eyaj73w)。
/// PATCH / DELETE は LawyerDto そのもの (parseLawyer 直通) のためここには置かない。

/** 追加 API の値ごとの結果。backend の `results[].status` と同語彙。 */
export type LawyerEmailAddStatus = 'added' | 'duplicate' | 'invalid';

export interface LawyerEmailAddResult {
  /** 送信した生の値 (エラー表示の突き合わせ用)。 */
  input: string;
  status: LawyerEmailAddStatus;
}

export interface LawyerEmailsAddOutcome {
  results: LawyerEmailAddResult[];
  /** mutation 後の Lawyer 全体 (詳細ストアの丸ごと置き換え用)。 */
  lawyer: Lawyer;
}

/// POST (`{ results, lawyer }`) の門番。未知 status は contract 破れとして throw。
export function parseLawyerEmailsAddResponse(raw: unknown): LawyerEmailsAddOutcome {
  const record = reqRecord(raw, 'lawyer_emails_add') as {
    results?: unknown;
    lawyer?: unknown;
  };
  const results = reqArray(record.results, 'lawyer_emails_add.results').map(
    (entry, index) => {
      const result = reqRecord(entry, `lawyer_emails_add.results[${index}]`) as {
        input?: unknown;
        status?: unknown;
      };
      const statuses: readonly LawyerEmailAddStatus[] = ['added', 'duplicate', 'invalid'];
      const status = statuses.find((candidate) => candidate === result.status);
      if (status === undefined) {
        throw new ResponseMappingError(
          `lawyer_emails_add.results[${index}].status`,
          'must be one of added / duplicate / invalid',
        );
      }
      return { input: String(result.input ?? ''), status };
    },
  );
  return {
    results,
    lawyer: parseLawyer(record.lawyer),
  };
}

